<template>



    <button class="btn btn-danger btn-sm"  v-html="buttonText" data-bs-toggle="modal" :data-bs-target="'#Modal' + TbtnId"
        v-on:click="buttonClick"></button>



    <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId" data-bs-backdrop="false">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ type }} 전송</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" style="font-size:13px;">
                        <input type="text" class="form-control" v-model="baseTitle" placeholder="제목"
                            :disabled="disableModifyText" style="font-size:13px;" />
                        <textarea v-model="baseText" class="form-control" placeholder="내용"
                            :disabled="disableModifyText" style="margin:4px 0; font-size:13px;"></textarea>
                        <div style="text-align:left;">
                        현금 결제방식인 경우 결제링크 전송이 불가합니다.</div>
                        <div style="text-align:right;">
                        현재 {{ msgLength }}/80Byte 입니다.</div>

                        <hr>
                    <table class="table ims" style="font-size:12px;">
                      <colgroup>
                        <col width=10%; />
                        <col width=30%; />
                        <col width=20%; />
                        <col width=20%; />
                      </colgroup>
                        <thead>
                            <tr style="text-align:center;">
                                <th>No.</th>
                                <th>수신번호</th>
                                    <th v-for="placeholder in placeholdersShow" v-bind:key="placeholder.name">
                                        [{{ placeholder.name }}]</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(receiver, i) in receivers" v-bind:key="i">
                                <td>{{ i+1 }}</td>
                                <td><input type="text" class="hidtype" v-model="receiver.phone"
                                        :disabled="receiver.locked" /></td>
                                <td v-for="(placeholder, i2) in placeholdersShow"
                                    v-bind:key="i + '/' + i2" style="text-align:center;"><input  class="op_input"
                                        v-model="receiver.args[i2]" :disabled="placeholder.locked" /></td>
                            </tr>{{ this.p_biz }}
                        </tbody>
                    </table>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                            :class="{disabled: msgLength > 80}" v-on:click="send()">전송</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
                    </div>

                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import axios from 'axios';
    export default {
        name: "imsmultiple",
        props: {
            placeholders: Array,
            baseTitle: {
                type: String,
                default: ""
            },
            baseText: {
                type: String,
                default: ""
            },
            receivers: Array,
            service: String,
            buttonClick: Function,
            disableModifyText: String, // title도 같이 제한걸림
            buttonText: {
                type: String,
                default: "<i class=\"bi bi-chat-dots\"></i> SMS 전송"
            },
            btnId: String
        },
        data: function () {
            return {
                TbtnId: this.btnId || Math.random().toString().substr(2, 5)
            }
        },
        methods: {
            urlReplace(str) {
                let match = str.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
                let final = str;
                if (!match) return str;
                match.map(url => {
                    final = final.replace(url, "00000000000000000000")
                })
                return final;
            },
            getReplacedMsg(msg, receiver){
                var text = msg;
                this.placeholders.forEach((v, i) => {
                    text = text.replaceAll("[" + v.name + "]", receiver.args[i]);
                })
                return text;
            },
            send() {
                this.receivers.forEach((v, i) => {

                    axios.post('/ims/' + v.phone, {
                        title: this.getReplacedMsg(this.baseTitle, v),
                        text: this.getReplacedMsg(this.baseText, v),
                        dstUser: v.targetStudent,
                        ref: v.ref,
                        type: this.type,
                        service: this.service,
                        p_bizId: v.p_bizId,
                        studentId: v.targetStudent,
                    }).then((response) => {
                        if (response.data.error) {
                            $.notify({
                                // options
                                message: response.data.error
                            }, {
                                // settings
                                type: 'danger',
                                z_index: 9999
                            });
                        } else {
                            $.notify({
                                // options
                                message: (i+1) + "번째 " + v.phone + " 전송에 성공하였습니다"
                            }, {
                                // settings
                                type: 'success',
                                z_index: 9999
                            });
                        }


                    })
                })
            },
        },
        computed: {
            // 계산된 getter
            msgLength: function () {
                // `this` 는 vm 인스턴스를 가리킵니다.
                return new Blob([this.urlReplace(this.baseText)]).size;
            },
            placeholdersShow: function(){
                return this.placeholders.filter((v) => !v.hidden)
            }
        }
    };
</script>
